$(document).ready(function() {
    // Wrap seed names every two words
    $('.seed-name').each(function() {
        let text = $(this).text().trim();
        let words = text.split(' ');
        let newText = [];
        for (let i = 0; i < words.length; i += 2) {
            newText.push(words.slice(i, i + 2).join(' '));
        }
        $(this).html(newText.join('<br>'));
    });

    // Функция для обновления слайдера
    window.updateSeedsSlider = function() {
        const $seedsList = $('.seeds-list');
        const $seedContainer = $('.seed-container');
        const $seedItems = $('.seed-item');
        const itemWidth = 109 + 4; // Width of each item (109px) + margin-right (4px)
        const visibleItems = 3; // Number of fully visible items
        const partialItemWidth = 31; // Pixels of the fourth item to show
        const leftPadding = 16; // Left padding of seeds-list
        let currentPosition = 0;

        // Calculate container width dynamically
        const containerWidth = $seedContainer.width();
        const totalItems = $seedItems.length;
        const maxPosition = Math.max(0, totalItems - visibleItems - (partialItemWidth / itemWidth));

        // Function to update slider position
        function updateSlider() {
            const translateX = -(currentPosition * itemWidth);
            $seedsList.css('transform', `translateX(${translateX}px)`);
        }

        // Click handler for "Show All" button to slide to next set
        $('.show-all-btn').off('click').on('click', function() {
            if (currentPosition < maxPosition) {
                currentPosition += visibleItems;
                if (currentPosition > maxPosition) {
                    currentPosition = maxPosition;
                }
            } else {
                currentPosition = 0; // Reset to start when reaching the end
            }
            updateSlider();
        });

        // Touch swipe functionality
        let startX = 0;
        let isDragging = false;
        let currentTranslate = 0;

        $seedsList.off('touchstart touchmove touchend').on('touchstart', function(e) {
            startX = e.touches[0].clientX;
            isDragging = true;
            $seedsList.css('transition', 'none');
        });

        $seedsList.on('touchmove', function(e) {
            if (!isDragging) return;
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            let newTranslate = currentTranslate + deltaX;
            $seedsList.css('transform', `translateX(${newTranslate}px)`);
            e.preventDefault();
        });

        $seedsList.on('touchend', function() {
            if (!isDragging) return;
            const currentX = event.changedTouches ? event.changedTouches[0].clientX : 0;
            const deltaX = currentX - startX;
            currentTranslate += deltaX;
            isDragging = false;
            $seedsList.css('transition', 'transform 0.5s ease');

            // Snap to nearest set of items
            currentPosition = Math.round(-currentTranslate / itemWidth);
            if (currentPosition < 0) currentPosition = 0;
            if (currentPosition > maxPosition) currentPosition = maxPosition;
            currentTranslate = -(currentPosition * itemWidth);
            updateSlider();
        });

        // Initial setup to show 3 items + 31px of the fourth
        const initialOffset = (visibleItems * itemWidth) + partialItemWidth - (containerWidth - leftPadding);
        if (initialOffset > 0) {
            currentPosition = 0;
            currentTranslate = 0;
        }
        updateSlider();
    };

    // Инициализация слайдера
    if (typeof updateSeedsSlider === 'function') {
        updateSeedsSlider();
    }
});